<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        max-height="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Przypisanie awarii
                </h1>
            </v-card-title>
            <v-card-text class="text-center">
                Przypisz awarię # {{ accident.id }} do {{ userName }}
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="loading"
                    data-sentry-label="Anuluj"
                    @click="onAbort"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="loading"
                    data-sentry-label="Potwierdź"
                    @click="saveAssignUser"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AssignUserDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        accident: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean
        }
    },
    computed: {
        userName() {
            return this.$store.state.user.userName
        },
    },
    methods: {
        saveAssignUser() {
            this.$emit('save-assign-user', {
                updateType: 'user',
                accidentStatusId: 10
            })
        },
        onAbort() {
            this.$emit('close-assign-user-dialog')
        }
    }
}
</script>